import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';
import { Coordinate } from '../model/coordinate';
import { EnvironmentService } from '../services/environment.service';
import { LocationService } from '../jurisdiction/location-form/location.service';

@Component({
  selector: 'app-apt-map',
  templateUrl: './apt-map.component.html',
  styleUrls: ['./apt-map.component.scss'],
})
export class AptMapComponent implements AfterViewInit, OnChanges {
  @Input() coordinates: Coordinate;

  @Output() sendGPS: EventEmitter<Coordinate> = new EventEmitter<Coordinate>();

  private map: L.Map;
  private marker: L.Marker;
  markerIcon: L.Icon<L.IconOptions>;

  constructor(private environmentService: EnvironmentService, private locationService: LocationService) {}

  ngAfterViewInit(): void {
    this.initMap();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.coordinates && !changes.coordinates.isFirstChange()) {
      this.updateMap();
    }
  }

  private initMap(): void {
    this.map = L.map('map', {
      center: [this.coordinates.y, this.coordinates.x],
      zoom: this.coordinates.z,
      maxZoom: 18,
    });

    this.markerIcon = L.icon({
      iconUrl: 'assets/images/marker-icon.png',
      iconSize: [24, 32],
      iconAnchor: [12, 32],
    });

    this.marker = L.marker([this.coordinates.y, this.coordinates.x], { icon: this.markerIcon }).addTo(this.map);

    new L.TileLayer(this.locationService.tileDataUrl, {
      minZoom: 1,
      maxZoom: 18,
      tileSize: 512,
      zoomOffset: -1,
      maxNativeZoom: 18,
    }).addTo(this.map);

    if (this.environmentService.mapData.showMapBoundary) {
      this.addBoundaries();
    }

    this.map.on('click', ({ latlng }) => {
      this.coordinates.x = latlng.lng;
      this.coordinates.y = latlng.lat;

      this.sendGPS.emit(this.coordinates);

      this.updateMap();
    });
  }

  private updateMap(): void {
    this.map.setView([this.coordinates.y, this.coordinates.x]);

    this.marker.setLatLng([this.coordinates.y, this.coordinates.x]);
    this.map.invalidateSize();
  }

  private addBoundaries() {
    const boundsCoordinates = this.environmentService.mapData.mapBoundary.map(([lat, long]) => L.latLng(lat, long));
    const bounds = L.latLngBounds(boundsCoordinates);

    this.map.setMaxBounds(bounds);
    this.map.setMinZoom(this.map.getBoundsZoom(this.map.options.maxBounds));
    this.map.on('drag', () => {
      this.map.panInsideBounds(bounds, { animate: false });
    });
  }
}
